<template>
  <div class="feature">
    <div class="item">
      <icon class="icon" :name="icon" /><span>{{ text }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.feature {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 3px;
  font-size: 0.8rem;
  font-weight: bold;

  & .icon {
    margin-right: 5px;
  }
}
</style>
